import db from "@/plugins/dexie";
import apirecebimentoweb from "@/services/api-recebimentoweb";

export default async function $_enviaVenda() {
  if (!navigator.onLine) return;

  try {
    const pendentes = await db.venda
      .filter(v => !v.venidnuvem)
      .toArray();

    if (!pendentes.length) return;
    
    console.log(`Enviando ${pendentes.length} vendas...`);

    for (const venda of pendentes) {
        try {
            const response = await apirecebimentoweb.post('/venda', venda);
            if (response.data && response.data.id) {
                await db.venda.update(venda.id, { 
                    venidnuvem: response.data.id,
                    vendataalteracao: response.data.vendataalteracao
                });
            }
        } catch (err) {
            console.error("Erro ao enviar venda:", err);
        }
    }
  } catch (error) {
    console.error("Erro em enviaVenda:", error);
  }
}